import React from 'react';
import PropTypes from 'prop-types';

import { FaqSelect } from '@sopranodesign/pulse-faqs';

const FaqCondition = ({ value, onChange }) => {
  const handleChange = option => {
    onChange(option ? option.value : null);
  };

  return <FaqSelect value={value} onChange={handleChange} />;
};

FaqCondition.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default FaqCondition;
